/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ResponseReasonType = {
    NotSpecified: 'NotSpecified',
    D41: 'D41',
    D42: 'D42',
    D43: 'D43',
    D44: 'D44',
    D45: 'D45',
    D58: 'D58',
} as const;
export type ResponseReasonType = typeof ResponseReasonType[keyof typeof ResponseReasonType];

